import React from 'react';
import styled, { css } from 'styled-components';

export interface RadioProps {
  selected: boolean;
  description: React.ReactNode;
  handleChange: Function;
}

const StyledRadioCaption = styled.div``;
const StyledRadioSelected = css`
  position: relative;
  border-color: ${({ theme }) => theme.colors.BLUE.B400};
  background: ${({ theme }) => theme.colors.BLUE.B400};

  :after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
`;
const StyledRadio = styled.div<{
  selected: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.BORDER};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  transition: background 0.3s, border-color 0.3s;

  ${props => props.selected && StyledRadioSelected};
`;
const StyledRadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0 2px 6px;
  border-radius: 4px;
  user-select: none;
  transition: color 0.3s;
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.colors.BLUE.B400};

    ${StyledRadio} {
      border-color: ${({ theme }) => theme.colors.BLUE.B400};
    }
  }
`;

const RadioComponent = ({
  selected,
  description,
  handleChange,
}: RadioProps) => {
  return (
    <StyledRadioWrapper onClick={() => handleChange()}>
      <StyledRadio selected={selected} />
      <StyledRadioCaption>{description}</StyledRadioCaption>
    </StyledRadioWrapper>
  );
};

export default RadioComponent;
